module.exports = __webpack_public_path__ + "static/4.15044c85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/4.jpg
// module id = 700
// module chunks = 168707334958949